import { useContext } from 'react'

import { useInitData } from '../../../../hooks'
import { BirdviewEffectiveScopeContext } from '../../DashboardBirdview.contexts'
import {
  getBirdviewListTarget,
  getBirdviewRowTarget,
} from '../../DashboardBirdview.utils.targets'

export function useBirdviewListTarget() {
  const { availableSections } = useInitData()

  const scope = useContext(BirdviewEffectiveScopeContext)

  function getListTarget(target) {
    return getBirdviewListTarget({ availableSections, scope, target })
  }

  function getRowListTarget({ id, target }) {
    return getListTarget(getBirdviewRowTarget({ id, target }))
  }

  return { getListTarget, getRowListTarget }
}
